
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"32","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#003653","fill-rule":"evenodd","d":"M20.625 16.875c2.916 0 5.357 1.179 5.494 2.851l.006.149v5c0 1.751-2.498 3-5.5 3-2.917 0-5.357-1.178-5.494-2.851l-.006-.149v-5l.006-.149c.137-1.672 2.578-2.851 5.494-2.851zm4.502 7.258c-1.002.77-2.656 1.242-4.502 1.242-1.845 0-3.5-.472-4.5-1.241v.741c0 1.01 1.979 2 4.5 2 2.437 0 4.367-.925 4.493-1.9l.007-.1.002-.742zM16.355 3.68v9.707h3.51c.168 0 .332.04.48.112l.109.062.1.074c.425.352.504.957.199 1.4l-.078.1-.78.881c-.526.03-1.033.098-1.514.2l1.544-1.742.012-.023-.003-.024-.017-.022-.023-.013-.028-.004h-4.51l-.001-8.071L7.2 15.525c-.019.022-.017.048.008.069l.023.013.03.004h4.51v8.07L14 21.163v1.51l-3.229 3.646V16.61h-3.51c-.168 0-.333-.038-.481-.111l-.108-.062-.101-.074a1.045 1.045 0 01-.199-1.4l.078-.1 9.905-11.183zm8.772 17.952c-1.002.77-2.657 1.242-4.502 1.242-1.845 0-3.5-.472-4.5-1.242v.742c0 1.01 1.979 2 4.5 2 2.437 0 4.367-.925 4.493-1.9l.007-.1.002-.742zm-4.502-3.758c-2.52 0-4.5.99-4.5 2s1.98 2 4.5 2 4.5-.99 4.5-2-1.98-2-4.5-2z"}})])
          )
        }
      }
    